export const MENU_ITEM_HEIGHT = 36;
export const MENU_OFFSET: [number, number] = [0, 0];
export const SELECTOR_BOX_SHADOW = '0 6px 8px rgba(255,255,255,0.15)';

export const paperBaseSx = {
  backgroundColor: 'gx.tileLight',
  minWidth: 200,
  boxShadow: SELECTOR_BOX_SHADOW
} as const;

export const menuItemStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 1,
  minHeight: MENU_ITEM_HEIGHT,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)'
  }
} as const;

export const activeMenuItemStyles = {
  ...menuItemStyles,
  backgroundColor: 'rgba(255, 255, 255, 0.08)'
} as const;

export const disabledMenuItemStyles = {
  ...menuItemStyles,
  cursor: 'not-allowed',
  opacity: 0.6,
  '&:hover': {
    backgroundColor: 'inherit'
  }
} as const;

export const menuItemTextStyles = {
  fontSize: '12px',
  fontWeight: 600
} as const;

export const getDashboardItemStyles = (disabled: boolean, isHovered: boolean) => {
  if (disabled) return disabledMenuItemStyles;
  if (isHovered) return activeMenuItemStyles;
  return menuItemStyles;
};
